import { ReactNode } from 'react'

import { cn } from '@/libs/tw'

type TagProps = {
	type: 'danger' | 'naturel' | 'highlight'
	children: ReactNode
}

export const Tag = ({ type, children }: TagProps) => {
	return (
		<div
			className={cn(
				'flex w-fit items-center justify-center rounded-24 px-16 py-8 text-naturel',
				type === 'danger' && 'bg-danger text-roomSelection-tagText',
				type === 'naturel' && 'bg-white text-tag-darkTextOnLightBackground',
				type === 'highlight' && 'bg-secondary '
			)}
		>
			{children}
		</div>
	)
}
